import React, {Component} from 'react'
import {connect} from 'react-redux'
import {compose} from 'recompose'
import CandidatesList from './candidates-content/CandidatesList'
import CandidateSearch from './candidates-content/CandidateSearch'
import ProtectedElement from '../common/helpers/ProtectedElement'
import {permissionByProfileType} from '../common/functions/permissions'

class Candidates extends Component {
  render() {
    if (this.props.overview === null){
      return '<div />';
    }

    return (
      <div>
        <CandidatesList vacancyId={this.props.vacancyId} />
        <br /><br /><br />
        {(this.props.overview.Status === 'Draft' || this.props.overview.Status === 'Active') &&
          <ProtectedElement permission={permissionByProfileType(this.props.overview.ProfileType, 'Suggest')}>
            <CandidateSearch vacancyId={this.props.vacancyId} skillType={this.props.overview.SkillType} />
          </ProtectedElement>
        }
      </div>
    )
  }
}

const mapStateToProps = (state, ownProps) => ({
  overview: state.vacancyPage.overview
})
const mapDispatchToProps = dispatch => ({
})
export default compose(connect(mapStateToProps, mapDispatchToProps))(Candidates)
